// extracted by mini-css-extract-plugin
export default {"work":"works_work__MZ5UL","steps":"works_steps__kiiZA","step":"works_step__nKE0I"};